import { ClientsState } from "../../models/ClientsState";

const importClientsByVendorSuccess = (state: ClientsState) => {
    state.importedClients = true;
    state.isLoading = false;
    state.isError = null;
}

export default importClientsByVendorSuccess;